import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import type {
  ISuspenseAccountSetting,
  ISuspenseAccountSettingFilter,
  ISuspenseAccountSettingInput,
} from "@models/master-data/suspenseAccountSettingModel"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"

/**
 * Feature-0370 — CRUD cấu hình tài khoản treo (khoá theo bộ 3 dự án + cặp tài khoản nợ/có).
 * Permission class-level: `PagesAdministration.SuspenseAccountSetting` (+ Read/Detail/Create/Update/Delete).
 */
class SuspenseAccountSettingService {
  public async getAll(
    params: ISuspenseAccountSettingFilter
  ): Promise<PagedResultDto<ISuspenseAccountSetting>> {
    const res = await http.get(
      "api/services/app/SuspenseAccountSetting/GetAll",
      { params }
    )
    return res.data.result
  }

  public async get(id: number): Promise<ISuspenseAccountSetting> {
    const res = await http.get("api/services/app/SuspenseAccountSetting/Get", {
      params: { id },
    })
    return res.data.result
  }

  /**
   * `id = 0` → tạo mới.
   *
   * ⚠️ BE chặn trùng bộ 3 `(projectId, debitAccountId, creditAccountId)` và trả
   * `SuspenseAccountSettingTripleAlreadyExists`. Để lỗi nổi lên cho interceptor hiển thị — đừng đoán
   * lại luật trùng ở FE.
   */
  public async createOrUpdate(
    body: ISuspenseAccountSettingInput
  ): Promise<ISuspenseAccountSetting> {
    const res = await http.post(
      "api/services/app/SuspenseAccountSetting/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async delete(id: number): Promise<void> {
    await http.delete("api/services/app/SuspenseAccountSetting/Delete", {
      params: { id },
    })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("DELETED_SUCCESSFULLY")
    )
  }
}

export default new SuspenseAccountSettingService()
